// extracted by mini-css-extract-plugin
export default {"logo":"Nav_logo__ONzAT","arrow":"Nav_arrow__VbHxO"};